import apiService from "./apiService";
import AppConstants from "../appConstants";

class SubjectService {
    getAllSubjects(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_SUBJECTS, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getSubjectDetails(id, params) {
        return new Promise((resolve, reject) => {
            apiService.get(`${AppConstants.URL_SUBJECTS}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    registerSubject(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_SUBJECTS, form, params, true)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    deleteSubject(id, params) {
        return new Promise((resolve, reject) => {
            apiService.delete(`${AppConstants.URL_SUBJECTS}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    report(params) {
        return new Promise((resolve, reject) => {
            apiService.downloadPublicFile(AppConstants.URL_SUBJECTS_REPORT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    updateApiCache(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_SUBJECTS_UPDATE_API_CACHE, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    
    // =====================================================================
    
}

export default new SubjectService();
